module.exports = __webpack_public_path__ + "static/img/star_person_service.3bddc7e3.png";